module.exports = __webpack_public_path__ + "img/toastBg.419e7499.png";